export const AgentTourBookingData = [
  {
    key: "1",
    id: "#TR-1245",
    tourName: "Joy Jubilee Jamboree",
    tourType: "Innovation Ignited",
    bookedBy: "Lynwood Dickens",
    bookedLocation: "Texas",
    travellers:"2 Adults, 1 Child",
    days: "4 Days, 3 Nights",
    pricing: "$11,569",
    bookedOn: "15 May 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "2",
    id: "#TR-3215",
    tourName: "LaughFest Carnival",
    tourType: "Escorted tour",
    bookedBy: "James Osborne",
    bookedLocation: "California",
    travellers:"2 Adults, 2 Child",
    days: "3 Days, 2 Nights",
    pricing: "$10,745",
    bookedOn: "20 May 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "3",
    id: "#TR-4581",
    tourName: "PlayPalooza Part",
    tourType: "Ground tour",
    bookedBy: "Steve Grieve",
    bookedLocation: "Newyork",
    travellers:"2 Adults, 1 Child",
    days: "2 Days, 1 Night",
    pricing: "$8,160",
    bookedOn: "04 Jun 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "4",
    id: "#TR-6545",
    tourName: "Romantic Places ",
    tourType: "Sightseeing tours",
    bookedBy: "Alene Downing",
    bookedLocation: "Florida",
    travellers:"1 Adult, 1 Child",
    days: "5 Days, 4 Nights",
    pricing: "$14,840",
    bookedOn: "17 Jun 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "5",
    id: "#TR-3256",
    tourName: "Whimsy Wonderland",
    tourType: "Sightseeing tours",
    bookedBy: "Carol Gardner",
    bookedLocation: "Georgia",
    travellers:"2 Adults, 2 Child",
    days: "3 Days, 2 Nights",
    pricing: "$10,450",
    bookedOn: "25 Jun 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "6",
    id: "#TR-3654",
    tourName: "Giggles & Games Gala",
    tourType: "Culinary tourism",
    bookedBy: "Enrique Archer",
    bookedLocation: "Las Vegas",
    travellers:"3 Adults, 2 Child",
    days: "4 Days, 3 Nights",
    pricing: "$12,600",
    bookedOn: "02 Jul 2025",
    status: "Cancelled",
    action: "cancelled",
  },
  {
    key: "7",
    id: "#TR-1458",
    tourName: "Fitness Frenzy",
    tourType: "Domestic tour operators",
    bookedBy: "Weston Carrasco",
    bookedLocation: "Texas",
    travellers:"2 Adults, 2 Child",
    days: "2 Days, 1 Night",
    pricing: "$9,380",
    bookedOn: "12 Jul 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "8",
    id: "#TR-6589",
    tourName: "Foodie Fiesta",
    tourType: "Luxury tours",
    bookedBy: "Bonnie Coleman",
    bookedLocation: "California",
    travellers:"1 Adult, 1 Child",
    days: "3 Days, 2 Nights",
    pricing: "$10,400",
    bookedOn: "26 Jul 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "9",
    id: "#TR-2315",
    tourName: "Dare DevCon",
    tourType: "Agritourism",
    bookedBy: "Aurora Conklin",
    bookedLocation: "Georgia",
    travellers:"2 Adults, 1 Child",
    days: "4 Days, 3 Nights",
    pricing: "$12,810",
    bookedOn: "10 Aug 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "10",
    id: "#TR-5414",
    tourName: "Innovation Ignited",
    tourType: "Romantic",
    bookedBy: "Robin Banks",
    bookedLocation: "Las Vegas",
    travellers:"3 Adults, 1 Child",
    days: "5 Days, 4 Nights",
    pricing: "$15,450",
    bookedOn: "22 Aug 2025",
    status: "Completed",
    action: "completed",
  },
  
];
